'use client';

import Link from 'next/link';
import { Badge } from '@/components/ui/badge';
import { Calendar, Eye } from 'lucide-react';

interface ArticleCardProps {
  id: string;
  title: string;
  summary?: string | null;
  cover_image?: string | null;
  tags?: string[];
  view_count?: number;
  created_at: string;
  href?: string;
}

export function ArticleCard({
  id,
  title,
  summary,
  cover_image,
  tags = [],
  view_count = 0,
  created_at,
  href,
}: ArticleCardProps) {
  const date = new Date(created_at).toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const linkHref = href || `/articles/${id}`;

  return (
    <Link href={linkHref} className="block">
      <div className="group relative rounded-2xl border border-white/[0.06] bg-white/[0.03] backdrop-blur-sm p-5 transition-all duration-300 hover:border-cyan-500/20 hover:bg-white/[0.06] hover:shadow-[0_0_30px_-5px_rgba(6,182,212,0.08)]">
        <h3 className="text-[15px] font-medium text-white/90 leading-relaxed line-clamp-2 group-hover:text-cyan-300 transition-colors duration-300">
          {title}
        </h3>

        {summary && (
          <p className="mt-3 text-sm text-white/40 leading-relaxed line-clamp-2">
            {summary}
          </p>
        )}

        {tags.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-1.5">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 text-[11px] rounded-full bg-white/[0.06] text-white/40"
              >
                {tag}
              </span>
            ))}
          </div>
        )}

        <div className="mt-4 flex items-center gap-4 text-[11px] text-white/25">
          <span className="flex items-center gap-1">
            <Calendar className="w-3 h-3" />
            {date}
          </span>
          {view_count > 0 && (
            <span className="flex items-center gap-1">
              <Eye className="w-3 h-3" />
              {view_count}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
